import { render, staticRenderFns } from "./CustomProductDetail.vue?vue&type=template&id=f19bd106&scoped=true&"
import script from "./CustomProductDetail.vue?vue&type=script&lang=js&"
export * from "./CustomProductDetail.vue?vue&type=script&lang=js&"
import style0 from "./CustomProductDetail.vue?vue&type=style&index=0&id=f19bd106&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19bd106",
  null
  
)

export default component.exports